import { mainCategoriesConstants } from './mainCategories.constants'

const initialState = {
  mainCategoryLevel0: [],
  mainCategoryLevel1: [],
  mainCategoryLevel2: [],
  mainCategoryLevel3: [],
  loadingMainCategories: false,
  loadingMainCategoriesForDocument: false,
  mainCategoriesForDocuments: {},
  error: null,
}

export function mainCategories(state = initialState, action) {
  switch (action.type) {
    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_LOADING:
      return {
        ...state,
        loadingMainCategories: true,
      }
    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_SUCCESS:
      return {
        ...state,
        loadingMainCategories: false,
        mainCategoryLevel0: action.mainCategories,
      }
    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_LOADING:
      return {
        ...state,
        loadingMainCategoriesForDocument: true,
      }
    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loadingMainCategoriesForDocument: false,
        mainCategoriesForDocuments: {
          ...state.mainCategoriesForDocuments,
          [`${action.tempFileId}-${action.level}`]: action.mainCategories,
        },
      }
    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_FOR_DOCUMENTS_RESET:
      return {
        ...state,
        loadingMainCategoriesForDocument: false,
        mainCategoriesForDocuments: {},
      }
    case mainCategoriesConstants.SET_LEVEL_0_FOR_DOCUMENT:
      return {
        ...state,
        mainCategoriesForDocuments: {
          ...state.mainCategoriesForDocuments,
          [`${action.tempFileId}-0`]: [...state.mainCategoryLevel0],
        },
      }
    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_LEVEL1_BY_ID_SUCCESS:
      return {
        ...state,
        loadingMainCategories: false,
        mainCategoryLevel0: state.mainCategoryLevel0,
        mainCategoryLevel1: action.mainCategories,
      }

    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_LEVEL2_BY_ID_SUCCESS:
      return {
        ...state,
        loadingMainCategories: false,
        mainCategoryLevel0: state.mainCategoryLevel0,
        mainCategoryLevel1: state.mainCategoryLevel1,
        mainCategoryLevel2: action.mainCategories,
      }

    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_LEVEL3_BY_ID_SUCCESS:
      return {
        ...state,
        loadingMainCategories: false,
        mainCategoryLevel0: state.mainCategoryLevel0,
        mainCategoryLevel1: state.mainCategoryLevel1,
        mainCategoryLevel2: state.mainCategoryLevel2,
        mainCategoryLevel3: action.mainCategories,
      }

    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_BY_ID_LOADING:
      return {
        ...state,
        loadingMainCategories: true,
        mainCategoryLevel0: state.mainCategoryLevel0,
        mainCategoryLevel1: state.mainCategoryLevel1,
        mainCategoryLevel2: state.mainCategoryLevel2,
        mainCategoryLevel3: state.mainCategoryLevel3,
      }

    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_BY_ID_ERROR:
      return {
        ...state,
        loadingMainCategories: false,
        error: 'Feil under lasting av hovedkategorier',
      }

    case mainCategoriesConstants.FETCH_MAIN_CATEGORIES_ERROR:
      return {
        ...state,
        loadingMainCategories: false,
        error: 'Feil under lasting av hovedkategorier',
      }

    default:
      return state
  }
}
